import React, { useEffect, useState } from "react";
import GlobalDialog from "../../components/mui/Dialogue/GlobalDialog";
import { ViewButton } from "../../components/mui/Buttons/Buttons";
import { useSelector } from "react-redux";
import { RelationShipTableHeader } from "../../components/datagrid/permissions/RelationShipTableHeader";
import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import CustomGridToolbar from "../../components/datagrid/GridToolBar";
import {
  getallPermissions,
  getallPermissionsRelationShips,
} from "../../redux/features/permissionSlice";
import { useDispatch } from "react-redux";
const RelationShipView = ({ rowData }) => {
  const { permissionData, relationShips, loading } = useSelector(
    (state) => state.permission
  );
  const [open, setOpen] = useState(false);
  const [gridSize, setGridSize] = useState(10);
  const dispatch = useDispatch();
  const handleCancel = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (open && rowData?.permissionID) {
      dispatch(getallPermissionsRelationShips(rowData?.permissionID));
    }
  }, [rowData?.permissionID, open]);
  return (
    <GlobalDialog
      maxWidth={"lg"}
      fullWidth
      title={"Permission Relationship"}
      open={open}
      setOpen={setOpen}
      closeButton={true}
      closeCondition={handleCancel}
      popupButton={
        <>
          <ViewButton size={"large"} action={() => setOpen(true)}>
            View
          </ViewButton>
        </>
      }
      content={
        <Box>
          <DataGrid
            components={{ Toolbar: CustomGridToolbar }}
            rows={relationShips?.data || []}
            columns={RelationShipTableHeader}
            loading={loading}
            getRowId={(row) => row.sl_no}
            pageSize={gridSize}
            autoHeight
            rowsPerPageOptions={[5, 10, 25, 50]}
            onPageSizeChange={(newGridSize) => setGridSize(newGridSize)}
          />
        </Box>
      }
    />
  );
};
export default RelationShipView;
